@if (spinnerService.loading()) {
  <div class="spinner-container">
    <app-spinner-load [key]="spinnerService.spinnerKey()"></app-spinner-load>
  </div>
}
<div
  class="principal-container"
  [ngClass]="{ 'loading-component': spinnerService.loading() || !hasPermission() }"
>
  @if (hasPermission() || isLessonsRoute()) {
    <app-global-sidebar
      [activeSearchType]="searchType()"
      [showLessonsOptions]="noProjectsAvailable()"
      (searchSelected)="openSearch($event)"
      (searchClosed)="closeOpenSearch()"
    />
  }
  @if (hasPermission()) {
    <div class="workspace" id="step3" [class.workspace--drawer-open]="isDrawerOpen()" [style.--drawer-width.px]="drawerWidth()" [hidden]="spinnerService.loading()">
      @if (isSearchOpen()) {
        <app-sidebar-open-search [workspace]="true" [(showAllResults)]="showAllSearchResults" [(searchType)]="searchType" />
      } @else {
        <router-outlet></router-outlet>
      }
      @if (
        !(
          !showOnlyNewSearch() &&
          errorDrawer() &&
          !spinnerConversational() &&
          !historyResponse()
        ) && hasAnySources()
      ) {
        <div class="sources-xl">
          <app-sources-drawer></app-sources-drawer>
        </div>
      }
      <div class="sources-xl">
        <app-search-panel-drawer></app-search-panel-drawer>
      </div>
    </div>
  }
</div>
<app-sidenav-drawer></app-sidenav-drawer>
<app-release-onboarding [appReady]="releaseOnboardingReady()" [noProjectsAvailable]="noProjectsAvailable()"></app-release-onboarding>
